import React from "react"
import Slider from "react-slick"

import t from "../locale"

const OfficesSliderTowerUpper = ({ lang }) => {
  const officesSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    fade: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <Slider {...officesSlider}>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("4 tenants", lang)} {t("(floor 10-24)", lang)}
              </h4>
              <p>
                621,5{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
                ({t("floors", lang)} 10-20) / 586,0{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />{" "}
                ({t("floors", lang)} 22-24)
              </p>
              <p></p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_upper_floor/Unity_Tower_upper_floor_4Tenants_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom offices-schema__wrapper-bottom--one-col">
            <ul>
              <li>
                {t("Tenant", lang)} 01 – 10 {t("workplaces", lang)}
              </li>
              <li>
                {t("Tenant", lang)} 02 – 11 {t("workplaces", lang)}
              </li>
              <li>
                {t("Tenant", lang)} 03 – 10 {t("workplaces", lang)}
              </li>
              <li>
                {t("Tenant", lang)} 04 – 9 {t("workplaces", lang)}
              </li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-Tower-upper-floor-4-tenants_v2-en.pdf")
                  : require("../assets/pdf/UNITY-Tower-upper-floor-4-tenants_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Modern version", lang)} {t("(floor 10-24)", lang)}
              </h4>
              <p>
                621,5{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />{" "}
                / 586,0{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>44 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_upper_floor/Unity_Tower_upper_floor_modern_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("2 office rooms / 1 person", lang)}</li>
              <li>{t("4 office rooms / 2 persons", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("4 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("2 phonebooths", lang)}</li>
              <li>{t("Relax and lounge area", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-Tower-upper-floor-modern_v2-en.pdf")
                  : require("../assets/pdf/UNITY-Tower-upper-floor-modern_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>
                {t("Traditional version", lang)} {t("(floor 10-24)", lang)}
              </h4>
              <p>
                621,5{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />{" "}
                / 586,0{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>60 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/Unity_Tower_upper_floor/Unity_Tower_upper_floor_traditional_v2.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("60 workplaces", lang)}</li>
              <li>{t("4 office rooms / 1 person", lang)}</li>
              <li>{t("2 office rooms / 3 persons", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("2 conference rooms", lang)}</li>
              <li>{t("Kitchenette", lang)}</li>
            </ul>
            <a
              href={
                lang === "en"
                  ? require("../assets/pdf/UNITY-Tower-upper-floor-traditional_v2-en.pdf")
                  : require("../assets/pdf/UNITY-Tower-upper-floor-traditional_v2.pdf")
              }
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      {/* <div>
        {lang === "en" ? (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-UTower-top-en.jpg")}
            alt=""
          />
        ) : (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-UTower-top-pl.jpg")}
            alt=""
          />
        )}
      </div> */}
    </Slider>
  )
}

export default OfficesSliderTowerUpper
